// extracted by mini-css-extract-plugin
export var root = "e3af5fc87d1e06bf48584e04bafb5a5c-css";
export var tag = "aa8d6c6b033284d549a4806e27c0d5cd-css";